import React, { useState, useRef } from "react";
import "./style.css";
// Icons
import { MdOutlineTextFields } from "react-icons/md";
import { MdRadioButtonChecked } from "react-icons/md";
import { FaRegSquareCheck } from "react-icons/fa6";
import { IoIosArrowDropdown } from "react-icons/io";
import { LuUpload } from "react-icons/lu";
import { HiCalendarDateRange } from "react-icons/hi2";

const Tabs = ({ setFieldType }) => {
  const [activeTab, setActiveTab] = useState("");
  const tabsRef = useRef(null);

  const tabs = [
    { id: "0", label: "Text", icon: <MdOutlineTextFields /> },
    { id: "1", label: "Multi Choice", icon: <MdRadioButtonChecked /> },
    { id: "2", label: "Checkbox", icon: <FaRegSquareCheck /> },
    { id: "3", label: "Dropdown", icon: <IoIosArrowDropdown /> },
    { id: "4", label: "File Upload", icon: <LuUpload /> },
    { id: "5", label: "Date", icon: <HiCalendarDateRange /> },
  ];

  const handleNext = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const handlePrevious = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  return (
    <div className="contentWrapper universal-bg-color">
      <div className="tabsWrapper universal-bg-color">
        <ul className="tabs" ref={tabsRef}>
          {tabs.map((tab) => (
            <li
              key={tab.id}
              data-id={tab.id}
              onClick={() => {
                setActiveTab(tab.id);
                setFieldType(tab.label);
              }}
            >
              <div className="tabContainer">
                <span  className={activeTab === tab.id ? "icon active" : "icon"}> {tab.icon}</span>
                <span className={activeTab === tab.id ? "label active" : "label color-white"}> {tab.label}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {/* <span className="next" onClick={handleNext}>
        &gt;
      </span>
      <span className="previous" onClick={handlePrevious}>
        &lt;
      </span> */}
    </div>
  );
};

export default Tabs;
